import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListSize = createAsyncThunk(
  "SizeNameList/fetchListSize",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/sizes/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const SizeNameListSlice = createSlice({
  name: "SizeNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListSize.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListSize.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListSize.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default SizeNameListSlice.reducer;
